import React from "react";
import { TextField } from "@material-ui/core";
import { FunctionComponent } from "react";
import UserDetailProps from "./userDetails";
import Autocomplete from "@material-ui/lab/Autocomplete";

export const PermanentAddress: FunctionComponent<UserDetailProps.PermanentAddressProps> = ({
  permAddressOne,
  setPermAddressOne,
  permAddressTwo,
  setPermAddressTwo,
  permPin,
  setPermPin,
  permCity,
  setPermCity,
  permState,
  setPermState,
  stateList,
}) => {
  const [inputValue, setInputValue] = React.useState("");
  const specialCharRegExp = "[a-zA-Z0-9 ]{1,}";

  return (
    <div>
      <div id="permanentAddress" className="flex flex-col justify-center mt-5 space-y-3">
        <div>
          <span className="px-3 py-2 bg-gray-300 w-[180px] ml-5 font-bold">
            Permanent Address *
          </span>
        </div>
        <div className="flex flex-col space-y-3">
          <div id="line1" className="space-y-3">
            <div className="flex justify-between">
              <TextField
                id="outlined-basic"
                variant="outlined"
                placeholder="Address Line One"
                value={permAddressOne}
                onChange={(e) => setPermAddressOne(e.target.value)}
                className="w-[630px]"
                required
                inputProps={{ pattern: { specialCharRegExp } }}
              />
              <TextField
                id="outlined-basic"
                variant="outlined"
                placeholder="Address Line Two"
                value={permAddressTwo}
                onChange={(e) => setPermAddressTwo(e.target.value)}
                className="w-[630px]"
                inputProps={{ pattern: { specialCharRegExp } }}
              />
            </div>
          </div>
          <div id="line2" className="flex justify-between space-x-5">
            <TextField
              id="outlined-basic"
              variant="outlined"
              placeholder="PINCODE"
              type="number"
              value={permPin}
              onChange={(e) => setPermPin(e.target.value)}
              className="w-[400px]"
              required
              inputProps={{ pattern: { specialCharRegExp } }}
            />
            <TextField
              id="outlined-basic"
              variant="outlined"
              placeholder="City"
              value={permCity}
              onChange={(e) => setPermCity(e.target.value)}
              className="w-[400px]"
              required
              inputProps={{ pattern: { specialCharRegExp } }}
            />
            {/* <select onChange={(e: any) => setPermState(e.target.value)}>
              <option>Please choose one option</option>
              {stateList.map((option, index) => {
                return <option key={index}>{option}</option>;
              })}
            </select> */}
            <div id="DTInput" className="-mt-3">
              <div className="flex flex-col">
                <div>
                  <Autocomplete
                    value={permState}
                    onChange={(event: any, newValue: string | null) => {
                      setPermState(newValue);
                    }}
                    inputValue={inputValue}
                    onInputChange={(event, newInputValue) => {
                      setInputValue(newInputValue);
                    }}
                    options={stateList}
                    style={{ width: 400, marginTop: "15px" }}
                    renderInput={(params) => <TextField {...params} label="State" />}
                  />
                </div>
              </div>
            </div>
            {/* <FormControl className="w-[400px]">
              <InputLabel id="demo-simple-select-label">State</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={permState}
                label="City"
                onChange={(e) => setPermState(e.target.value)}
              >
                {stateList.map((element) => (
                  <MenuItem key={element} value={element}>
                    {element}
                  </MenuItem>
                ))}
              </Select>
            </FormControl> */}
          </div>
        </div>
      </div>
    </div>
  );
};
